export default __webpack_public_path__ + "static/media/contentCopy.58a17449.svg";